var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import format from 'date-fns/format';
import dateParse from 'date-fns/parse';
import * as React from 'react';
import { DATE_FORMAT_FOR_DB } from '../../constants/constants';
import { getDateFnsLocale } from '../../util-components/datetime';
import Calendar from '../calendar';
import Input from '../input';
import Popover from '../popover';
import Styled from './style';
export var DatePickerActions;
(function (DatePickerActions) {
    DatePickerActions["ADD_DATE"] = "add_date";
    DatePickerActions["REMOVE_DATE"] = "remove_date";
})(DatePickerActions || (DatePickerActions = {}));
var getCalendarDateValue = function (date) {
    if (date !== '') {
        return dateParse(date, DATE_FORMAT_FOR_DB, new Date());
    }
    return undefined;
};
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapperRef = React.createRef();
        _this.calendarRef = React.createRef();
        _this.dateInputRef = React.createRef();
        _this.pageClick = function (event) {
            if (_this.wrapperRef.current &&
                _this.calendarRef.current &&
                (!_this.wrapperRef.current.contains(event.target) && !_this.calendarRef.current.contains(event.target))) {
                _this.setState({
                    isPopoverOpen: false,
                });
            }
        };
        _this.handleInputOnFocus = function () {
            _this.setState({ isPopoverOpen: true }, function () {
                _this.dateInputRef.current.inputRef.current.focus();
            });
        };
        _this.handleKeyDown = function (event) {
            if (event.key === 'Tab') {
                _this.setState({
                    isPopoverOpen: false,
                });
            }
        };
        _this.onDateChange = function (date) {
            var callBack = _this.props.callBack;
            _this.setState({
                isPopoverOpen: false,
                value: format(date, DATE_FORMAT_FOR_DB),
            });
            callBack && callBack(DatePickerActions.ADD_DATE, format(date, DATE_FORMAT_FOR_DB));
        };
        _this.state = {
            isPopoverOpen: _this.props.open ? _this.props.open : false,
            value: _this.props.value,
        };
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        window.addEventListener('mousedown', this.pageClick, false);
    };
    DatePicker.prototype.componentWillUnmount = function () {
        window.removeEventListener('mousedown', this.pageClick, false);
    };
    DatePicker.prototype.componentDidUpdate = function (prevProps) {
        var value = this.props.value;
        if (prevProps.value !== value) {
            this.setState({ value: value });
        }
    };
    DatePicker.prototype.render = function () {
        var _a = this.state, isPopoverOpen = _a.isPopoverOpen, value = _a.value;
        var _b = this.props, activeStartDate = _b.activeStartDate, locale = _b.locale, minDate = _b.minDate, maxDate = _b.maxDate, placeholder = _b.placeholder;
        var date = value.split('-');
        return (React.createElement(Styled, { ref: this.wrapperRef, className: this.props.className },
            React.createElement(Popover, { trigger: React.createElement(Input, { disabled: this.props.disabled || false, ref: this.dateInputRef, value: value && format(new Date(Number(date[0]), Number(date[1]) - 1, Number(date[2])), 'PP', { locale: getDateFnsLocale() }), onFocus: this.handleInputOnFocus, onKeyDown: this.handleKeyDown, placeholder: placeholder || '' }), on: "click", content: React.createElement("div", { ref: this.calendarRef },
                    React.createElement(Calendar, { callback: this.onDateChange, locale: locale, minDate: minDate, maxDate: maxDate, activeStartDate: activeStartDate, value: getCalendarDateValue(value) })), open: isPopoverOpen, position: "bottom center", className: "calendar" })));
    };
    DatePicker.defaultProps = {
        locale: 'en-US',
        showRemove: false,
    };
    return DatePicker;
}(React.PureComponent));
export default DatePicker;
//# sourceMappingURL=index.js.map